export default async function(path){
  return (await fetch(path)).json();
}


// WEBPACK FOOTER //
// ./src/utilities/fetchJSON.js